/* Confirm for delete */

const formDeleteUser = document.querySelector('#form-delete-user');

if (formDeleteUser) {
  formDeleteUser.addEventListener('submit', (event) => {
    if (confirm(formDeleteUser.dataset.confirmMessage)) {
      formDeleteUser.action = formDeleteUser.dataset.action;
    } else {
      event.preventDefault();
    }
  });
}
